export default {
  BT_HDP: "让球",
  BT_OU: "大/小",
  BT_ML: "独赢",
  BT_1X2: "1X2",
  BT_1X2HDP: "三项让分投注",
  BT_CS: "波胆",
  BT_OE: "单/双",
  BT_DC: "双重机会",
  BT_HTFT: "半场/全场",
  BT_FGLG: "最先进球/最后进球",
  BT_TG: "总进球",
  BT_OR: "优胜冠军",
  BT_ORZ: "优胜冠军",

  BT_ANB: "客场无效",
  BT_BS: "双方/一方/两者皆不得分",
  BT_CL: "零失球",
  BT_DNB: "平手无效",
  BT_HNB: "主场无效",
  BT_TWTN: "零失球的胜方",

  BT_HDPF: "全场让球",
  BT_OUF: "全场大",
  BT_MLF: "全场独赢",
  BT_1X2F: "全场1X2",
  BT_1X2HDPF: "全场三项让分投注",
  BT_CSF: "全场波胆",
  BT_OEF: "全场单",
  BT_DCF: "全场双重机会",
  BT_FGLGF: "全场最先进球/最后进球",
  BT_TGF: "全场总进球",

  BT_HDPH: "上半场让球",
  BT_OUH: "上半场大/小",
  BT_MLH: "上半场独赢",
  BT_1X2H: "上半场1X2",
  BT_1X2HDPH: "上半场三项让分投注",
  BT_CSH: "上半场波胆",
  BT_OEH: "上半场单/双",
  BT_DCH: "上半场双重机会",
  BT_FGLGH: "上半场最先进球/最后进球",
  BT_TGH: "上半场总进球",

  BT_HDPOU: "让球&大小",
  BT_PARLAY: "混合过关",
  BT_FT: "全场",
  BT_1H: "上半场",
  BT_2H: "下半场",

  BT_FG: "最先进球",
  BT_LG: "最后进球",
  BT_HFG: "主先",
  BT_AFG: "客先",
  BT_HLG: "主后",
  BT_ALG: "客后",
  BT_NG: "无进球",
  BT_HY: "主是",
  BT_HN: "主否",
  BT_AY: "客是",
  BT_AN: "客否",

  BT_HD_DC: "主 或 和局",
  BT_HA_DC: "主 或 客",
  BT_DA_DC: "客 或 和局",
  BT_HH: "主主",
  BT_HD: "主和",
  BT_HA: "主客",
  BT_DH: "和主",
  BT_DD: "和和",
  BT_DA: "和客",
  BT_AH: "客主",
  BT_AD: "客和",
  BT_AA: "客客",

  BT_H: "主",
  BT_A: "客",
  BT_D: "和局",

  BT_Y: "是",
  BT_N: "否",

  BT_FT1: "全场.1",
  BT_FT2: "全场.2",
  BT_FTX: "全场.X",

  BT_HT1: "半场.1",
  BT_HT2: "半场.2",
  BT_HTX: "半场.X",

  LOT_BS: "大/小",
  LOT_BIG: "大",
  LOT_SMALL: "小",
  LOT_OE: "单/双",
  LOT_ODD: "单",
  LOT_EVEN: "双",
  LOT_OU: "大/小",
  LOT_OVER: "大",
  LOT_UNDER: "小",

  BT_ALL: "@:ui.bet_list",

  D_1: "正字",
  D_2: "正字与反字",
  D_3: "包字",
  D_4: "全保",
  D_5: "包字最后3个号码",
  D_6: "包字最后2个号码",

  D_BIG: "大",
  D_SMALL: "小",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO",

  BT_OEHM: "主队单双 | 主队单/双",  
  BT_OEHMH: "上半场主队单双 | 上半场主队单/双",  
  BT_OEAW: "客队单双 | 客队单/双",  
  BT_OEAWH: "上半场客队单双 | 上半场客队单/双",  

  BS_OEHM: "全场主队单双 | 全场主队单/双",  
  BS_OEHMH: "上半场主队单双 | 上半场主队单/双",  
  BS_OEAW: "全场客队单双 | 全场客队单/双",  
  BS_OEAWH: "上半场客队单双 | 上半场客队单/双",  

  MB_OVER: "大 (4,5,6)",  
  MB_UNDER: "小 (1,2,3)",  
  MB_ODD: "单 (1,3,5)",  
  MB_EVEN: "双 (2,4,6)",  

  BS_1X2OU: "胜平负 + 大小球",
  BT_1X2OU: "胜平负 + 大小球",
  BT_1O: "主胜大",
  BT_1U: "主胜小",
  BT_2O: "客胜大",
  BT_2U: "客胜小",
  BT_XO: "平局大",
  BT_XU: "平局小",

  BS_DCOU: "双重机会 + 大小球",
  BT_DCOU: "双重机会 + 大小球",
  BT_HDO: "主胜或平局大",
  BT_HDU: "主胜或平局小",
  BT_HAO: "客胜或平局大",
  BT_HAU: "客胜或平局小",
  BT_DAO: "主胜或客胜大",
  BT_DAU: "主胜或客胜小",

  BS_OUOE: "大小球 + 单双",
  BT_OUOE: "大小球 + 单双",
  BK_OO: "大单",
  BK_OE: "大双",
  BK_UO: "小单",
  BK_UE: "小双",

  BS_HTFTOE: "半全场 + 单双",
  BT_HTFTOE: "半全场 + 单双",
  BK_EO: "半场双全场单",
  BK_EE: "半场双全场双",

  BS_WM: "获胜比分差",
  BT_WM: "获胜比分差",
  BK_H1: "主胜1球",
  BK_H2: "主胜2球",
  BK_H3Up: "主胜3+球",
  BK_A1: "客胜1球",
  BK_A2: "客胜2球",
  BK_A3Up: "客胜3+球",
  BK_D: "有进球平局(0-0除外)",
  BK_NG: "无进球",

  BS_ETG: "总进球数",
  BT_ETG: "总进球数",
  BS_EHTG: "主队总进球数",
  BT_EHTG: "主队总进球数",
  BS_EATG: "客队总进球数",
  BT_EATG: "客队总进球数",
  BS_ETGH: "上半场总进球数",
  BT_ETGH: "上半场总进球数",
  BS_EHTGH: "上半场主队进球数",
  BT_EHTGH: "上半场主队进球数",
  BS_EATGH: "上半场客队进球数",
  BT_EATGH: "上半场客队进球数",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "半场/全场 精准比分",
  BS_CSHTFT: "半场/全场 精准比分",
  BT_ETGHTFT: "半场/全场 精准总进球",
  BS_ETGHTFT: "半场/全场 精准总进球",

  MBR_SINGLE: "Single",
  MBR_TRIPS: "Trips",
  MBR_PAIR: "Pair",
};